import ignored from './noindex.json'

function getNoindex (name) {
  var link = ''
  var links = document.getElementsByTagName('meta')
  for (var i = 0; i < links.length; i++) {
    if (links[i].getAttribute('name') === name) {
      link = links[i]
    }
  }
  if (link === '') {
    link = document.createElement('meta')
    link.setAttribute('name', name)
    link.setAttribute('content', 'noindex')
  }
  return link
}

function checkPath () {
  var result = false
  ignored.path.forEach(item => {
    var rgx = new RegExp(item, 'g')
    if (location.href.match(rgx) !== null || location.host === item) { result = true }
  })
  return result
}

function addNoIndex () {
  document.head.appendChild(getNoindex('robots'))
  document.head.appendChild(getNoindex('googlebot'))
}

function removeNoIndex () {
  if (typeof getNoindex('robots').remove === 'function' && typeof getNoindex('googlebot').remove === 'function') {
    getNoindex('robots').remove()
    getNoindex('googlebot').remove()
  }
}

const noindex = {
  update: function (meta) {
    var force = meta.noindex || false
    if (force || checkPath()) {
      addNoIndex()
      return true
    } else {
      removeNoIndex()
      return false
    }
  }
}

export { noindex }



// WEBPACK FOOTER //
// ./src/router/noindex.js